import React, { Component } from 'react';

class InfoBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };

        this.onHeaderClick = this.onHeaderClick.bind(this);
    }

    onHeaderClick() {
        this.setState({"expanded": !this.state.expanded});
    }

    render() {
        return (
            <div className="InfoBox">
                <div className="InfoBox-header" onClick={this.onHeaderClick}>
                    <span className="glyphicon glyphicon-info-sign InfoBox-infoIcon"></span>
                    { this.props.header }
                    <span className={"glyphicon InfoBox-caret " +
                    ( this.state.expanded ?
                        "glyphicon-triangle-top" :
                        "glyphicon-triangle-bottom")
                    }>
                    </span>
                </div>
                { this.state.expanded &&
                    <div className="InfoBox-text">
                        { this.props.text }
                    </div>
                }
            </div>
        );
    }
}

export default InfoBox;


// WEBPACK FOOTER //
// ./src/components/InfoBox.js